/* global ViewerUI */
/* global $ */

(function (scope) {
  "use strict";

  var PrintSolidityCheckView = (scope.PrintSolidityCheckView = function (
    controller,
    design,
    viewerUI
  ) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewerUI;
    this.viewer = this.viewerUI.viewer;
    this.enabled = false;

    this.$el = $("#PrintViewerView");
    this.$el.on(
      "change",
      "#solidity-check-thin-points #thinall",
      this.toggleThinPoints.bind(this)
    );
    this.$el.on(
      "change",
      "#solidity-check-thin-points ul input",
      this.toggleThinPoint.bind(this)
    );

    this.thinPoints = {};
    this.solidityCheckLabels = [];
    this.displayedThinPoints = {};

    // Click to display solidity check needs this...
    this.viewerUI.operationsAvailable = {
      script_id: window.scriptDesignOperationId,
    };
  });

  PrintSolidityCheckView.prototype.solidityUpdateThresholds = function () {
    if (this.enabled) {
      var solidity = this.design.material.get_solidity_threshold(
        this.design.size
      );
      this.viewer.$jself.Sculpteo3DViewer({
        solidity: [solidity * 0.7, solidity * 2.0],
      });

      //update the threshold value on solidity check view
      $(".solidity-check-threshold-value", this.el).html(
        this.design.material.threshold * 2 + "mm"
      );
    }
  };

  /**
   * Toggle solidity check
   * @public
   * @param {bool} enabled
   */
  PrintSolidityCheckView.prototype.toggleSolidityCheck = function (enabled) {
    this.enabled = enabled;

    this.removeThinPointsList();
    this.viewerUI.toggle_solidity_check(enabled);
    this.viewerUI.toggle_display_grid(enabled);

    $("#solidity-check-legend", this.$el).toggleClass("hidden", !enabled);
    $("#solidity-check-threshold", this.$el).toggleClass("hidden", !enabled);

    if (enabled) {
      //solidityUpdateThresholds used to be call above but seems to bug
      //so we call it only when solidity check is active
      this.solidityUpdateThresholds();
      this.design
        .get_local_thickness_minima()
        .done(this.toggleThinPointsList.bind(this));

      this.viewer.bind("camera", this.solidityCheckOnCameraMove.bind(this));
      this.viewer.bind("zoom", this.solidityCheckOnCameraMove.bind(this));
      this.viewer.bind("pan", this.solidityCheckOnCameraMove.bind(this));
    } else {
      this.clearSolidityPoints();
      this.viewer.unbind("click", this.solidityCheckOnClick);
      this.viewer.unbind("camera", this.solidityCheckOnCameraMove);
      this.viewer.unbind("zoom", this.solidityCheckOnCameraMove);
      this.viewer.unbind("pan", this.solidityCheckOnCameraMove);
    }
  };

  PrintSolidityCheckView.prototype.scaleUpdated = function () {
    if (this.enabled) {
      this.clearSolidityPoints();
      this.removeThinPointsList();
      this.solidityUpdateThresholds();

      this.design
        .get_local_thickness_minima()
        .done(this.toggleThinPointsList.bind(this));
    }
  };

  /**
   * Display thin points when solidity check is enabled
   * @private
   * @param {object} thinPoints
   */
  PrintSolidityCheckView.prototype.toggleThinPointsList = function (
    thinPoints
  ) {
    if (!thinPoints.minima.length) {
      this.removeThinPointsList();
    } else {
      for (var i = 0; i < thinPoints.minima.length; ++i) {
        // Thin point data
        var point_id = "thin" + i;
        var name = i + 1 + " " + gettext(" - thickness: ");
        var coord_array = thinPoints.minima[i].slice();
        var coord = {
          x: coord_array[0],
          y: coord_array[1],
          z: coord_array[2],
          e: coord_array[3],
        };
        var op_coord = coord_array[4];
        var vec = coord_array[5];
        var data = {
          name: name,
          point_data: {
            thickness: coord.e,
            distance: 1.0,
            pos: op_coord,
          },
          params: {
            x: coord.x,
            y: coord.y,
            z: coord.z,
            e: coord.e,
            type: "add",
            state: 0,
            dx: 0,
            dy: 0,
            dz: 0,
          },
        };

        this.thinPoints[point_id] = data;

        // Adding HTML
        var $item = $("li.tpl", this.$el).clone().removeClass("tpl hidden");
        $item
          .find("label")
          .attr("for", point_id)
          .text("#" + (i + 1));
        $item.find("input").attr("id", point_id);
        $item.appendTo($("#solidity-check-thin-points ul", this.$el));
      }

      $("#solidity-check-thin-points", this.$el).removeClass("hidden");
    }
  };

  /**
   * Clears the thin points list
   * @private
   */
  PrintSolidityCheckView.prototype.removeThinPointsList = function () {
    $("#solidity-check-thin-points", this.$el).addClass("hidden");
    $('#solidity-check-thin-points li:not(".tpl")', this.$el).remove();
    this.thinPoints = {};
  };

  PrintSolidityCheckView.prototype.toggleThinPoints = function (e) {
    var $checkboxes = $(
      '#solidity-check-thin-points li:not(".tpl") input[type=checkbox]'
    );

    if ($(e.currentTarget).is(":checked")) {
      $checkboxes.prop("checked", true).each(this.toggleThinPoint.bind(this));
    } else {
      $checkboxes.prop("checked", false).each(this.toggleThinPoint.bind(this));
    }
  };

  PrintSolidityCheckView.prototype.toggleThinPoint = function (e) {
    var $checkbox;

    if (arguments.length === 1) {
      $checkbox = $(arguments[0].currentTarget);
    } else {
      $checkbox = $(arguments[1]);
    }

    var point_id = $checkbox.attr("id");
    var data = this.thinPoints[point_id];

    if ($checkbox.is(":checked")) {
      if (!this.displayedThinPoints[point_id]) {
        this.displayedThinPoints[point_id] = this.drawSolidityPoint(data);
      }
    } else if (this.displayedThinPoints[point_id]) {
      this.displayedThinPoints[point_id].remove();
      delete this.displayedThinPoints[point_id];
    }
  };

  /**
   * Called when the user clicks on the viewer to measure solidity
   * @param x X coordinate of the ray start
   * @param y Y coordinate of the ray start
   * @param z Z coordinate of the ray start
   * @param dx X direction of the ray
   * @param dy Y direction of the ray
   * @param dz Z direction of the ray
   * @param node_key Node instance that was hit with the ray
   */
  PrintSolidityCheckView.prototype.solidityCheckOnClick = function (
    x,
    y,
    z,
    dx,
    dy,
    dz,
    node_key
  ) {
    var point_id = (Math.random() * 1000 + 100).toFixed();
    x = parseFloat(x);
    y = parseFloat(y);
    z = parseFloat(z);
    dx = parseFloat(dx);
    dy = parseFloat(dy);
    dz = parseFloat(dz);

    this.design.measure_wall_thickness(x, y, z, dx, dy, dz, undefined).then(
      function (data) {
        this.displayedThinPoints[point_id] = this.drawSolidityPoint({
          point_data: data,
          params: { x: x, y: y, z: z, dx: dx, dy: dy, dz: dz },
        });
      }.bind(this)
    );
  };

  var solidityCheck = {
    active: false,
    labels: [],
    coneNode: null,
    fact: null,
  };

  PrintSolidityCheckView.prototype.solidityCheckOnCameraMove = function () {
    var world_to_viewport_transform = this.viewer.getWorldToViewportTransform();

    for (var i in this.solidityCheckLabels) {
      var label = this.solidityCheckLabels[i];
      label.update_position(world_to_viewport_transform);
    }
  };

  /**
   * Create a new cone node with the specified transform
   * @param transform The transform of the new cone node
   * @return {*} Returns a node
   */
  PrintSolidityCheckView.prototype.solidityCheckSetupCone = function (
    transform
  ) {
    var node = this.viewer.createNode(solidityCheck.coneNode.id, transform);
    node.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);
    node.setMaterial(this.viewerUI.get_cursor_material());
    node.setFlags("C:AO");
    var scene = this.viewer.getScene();

    scene.appendChild(node);
    this.viewer.updateSceneTransform();

    return node;
  };

  /**
   * Creates a new cone node, creates the 3d model if not created.
   * @param node_id The id of the new node (not used?)
   * @param transform The transform of the new node
   * @param fact Multiplication factor for the cone size
   * @return {*} Returns a deferred that will resolve when the node is loaded
   */
  PrintSolidityCheckView.prototype.solidityCheckLoadCone = function (
    node_id,
    transform,
    fact
  ) {
    var dfd = $.Deferred();
    if (!solidityCheck.coneNode || fact !== solidityCheck.fact) {
      solidityCheck.fact = fact;
      var dfd_init = init_cone_node(
        this.viewer,
        scriptDesignOperationId,
        solidityCheck.fact,
        "measurement_cone_node"
      );
      dfd_init.then(
        function (coneNode) {
          solidityCheck.coneNode = coneNode;
          var node = this.solidityCheckSetupCone(transform);
          dfd.resolve(node);
        }.bind(this)
      );
    } else {
      var node = this.solidityCheckSetupCone(transform);
      dfd.resolve(node);
    }
    return dfd.promise();
  };

  PrintSolidityCheckView.prototype.clearSolidityPoints = function () {
    var labels = this.solidityCheckLabels;

    for (var i in labels) {
      var label = labels[i];

      label.detach();

      if (label.fcone_node) {
        label.fcone_node.detach();
      }

      if (label.bcone_node) {
        label.bcone_node.detach();
      }

      delete labels[label.key];
    }
  };

  /**
   * Display solidity spot in the viewer
   *
   * @param {object} thinPointData
   * @return {*} Returns the UI container for the thickness
   */
  PrintSolidityCheckView.prototype.drawSolidityPoint = function (
    thinPointData
  ) {
    var data = thinPointData.point_data;
    var params = thinPointData.params;
    var name = thinPointData.name;

    if (!data.thickness || !data.distance) {
      return;
    }

    var part = this.design;
    var _currentDesign = this.design;

    var x = params.x;
    var y = params.y;
    var z = params.z;
    var dx = params.dx;
    var dy = params.dy;
    var dz = params.dz;

    var labels = this.solidityCheckLabels;
    var pointsize = 10;
    var margin = 20;
    var scale = part.size.designerScale * part.size.userScale;
    var unit = part.size.unit;

    // Create a cube at the intersection location
    var distance = data.distance;
    var thickness = data.thickness;
    var ix = x + distance * dx;
    var iy = y + distance * dy;
    var iz = z + distance * dz;
    var id = "wall_thickness_point_";

    if (!name) {
      name = "thickness";
    }

    for (var i = 0; i < 32; i++) {
      id += ((Math.random() * 16) | 0).toString(16);
    }

    var defaultFont = "arial";

    // Create label
    var label = this.viewer.createUILabel({
      font: defaultFont,
      fontWeight: "bold",
      textHeight: 10,
      text: gettext(name) + " " + (thickness * scale).toFixed(2) + "" + unit,
      textColor: { r: 255, g: 255, b: 255, a: 255 },
      backgroundColor: { r: 0, g: 0, b: 0, a: 192 },
      borderColor: { r: 255, g: 255, b: 255, a: 255 },
      borderWidth: 1,
      borderRadius: 4,
    });

    var point = this.viewer.createUILayer({
      backgroundColor: { r: 0, g: 0, b: 255, a: 255 },
      borderColor: { r: 255, g: 255, b: 255, a: 255 },
      borderRadius: pointsize * 0.5,
      borderWidth: 1,
    });

    var line = this.viewer.createUILayer({
      backgroundColor: { r: 255, g: 255, b: 0, a: 255 },
      borderColor: { r: 255, g: 255, b: 255, a: 255 },
      borderWidth: 1,
    });

    var container = this.viewer.createUILayer({});

    container.key = id;
    container.setFrame(0, 0, label.frame.w + 2, label.frame.h + 2 + margin);

    var root = this.viewer.getRootLayer();

    container.line = line;
    container.appendChild(line);
    container.label = label;
    label.setFrame(0, margin);
    container.appendChild(label);
    labels[container.key] = container;
    var world_to_viewport_transform = this.viewer.getWorldToViewportTransform();

    container.remove = function () {
      this.detach();

      if (this.fcone_node) {
        this.fcone_node.detach();
      }

      if (this.bcone_node) {
        this.bcone_node.detach();
      }

      _currentDesign.delete_wall_thickness(x, y, z, dx, dy, dz);
      delete labels[container.key];
    };

    if (data.pos) {
      line.setFrame(container.frame.w * 0.5, 0, 0, margin);
      var size = this.viewer.getSceneSize();
      var fact = (1 / 10) * Math.min(size.x, size.y, size.z);

      var p = [ix, iy, iz];

      var n = [data.pos[0] - ix, data.pos[1] - iy, data.pos[2] - iz];
      var sz = Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);

      n[0] /= sz;
      n[1] /= sz;
      n[2] /= sz;
      var n2 = [-n[0], -n[1], -n[2]];

      var extPos = [p[0] - n[0] * fact, p[1] - n[1] * fact, p[2] - n[2] * fact];
      var extPos2 = [
        data.pos[0] - n2[0] * fact,
        data.pos[1] - n2[1] * fact,
        data.pos[2] - n2[2] * fact,
      ];

      container.e = [p[0], p[1], p[2], 1];
      container.p = [extPos[0], extPos[1], extPos[2], 1];

      var transform = new Sculpteo3DViewerTransform3D();
      var angle = Math.acos(
        Sculpteo3DViewerTransform3D.dotProduct(n, [0, 0, 1])
      );
      var v = Sculpteo3DViewerTransform3D.crossProduct([0, 0, 1], n);

      transform = transform.rotate(angle, v[0], v[1], v[2]);
      transform = transform.translate(extPos[0], extPos[1], extPos[2]);

      var transform2 = new Sculpteo3DViewerTransform3D();
      var v2 = Sculpteo3DViewerTransform3D.crossProduct([0, 0, 1], n2);
      var angle2 = Math.acos(
        Sculpteo3DViewerTransform3D.dotProduct(n2, [0, 0, 1])
      );

      transform2 = transform2.rotate(angle2, v2[0], v2[1], v2[2]);
      transform2 = transform2.translate(extPos2[0], extPos2[1], extPos2[2]);

      container.prev = 0;
      container.update_position = function (world_to_viewport_transform) {
        var E = world_to_viewport_transform.x(this.e);
        var P = world_to_viewport_transform.x(this.p);

        if (E[1] - P[1] < 0) {
          this.setFrame(P[0] - this.frame.w * 0.5 - 1, P[1] - 1);

          if (this.prev >= 0) {
            this.label.setFrame(0, margin);
            this.line.setFrame(this.frame.w * 0.5, 0);
            this.prev = -1;
          }
        } else {
          this.setFrame(P[0] - this.frame.w * 0.5 - 1, P[1] - this.frame.h + 1);

          if (this.prev <= 0) {
            this.label.setFrame(0, 0);
            this.line.setFrame(this.frame.w * 0.5, this.frame.h - margin);
            this.prev = 1;
          }
        }
      };

      this.solidityCheckLoadCone("f" + container.key, transform, fact).then(
        function (node) {
          container.fcone_node = node;
          this.solidityCheckLoadCone(
            "b" + container.key,
            transform2,
            fact
          ).then(function (node) {
            container.bcone_node = node;
            container.update_position(world_to_viewport_transform);
            root.appendChild(container);
          });
        }.bind(this)
      );
    } else {
      point.setFrame(
        (container.frame.w - pointsize) * 0.5,
        0,
        pointsize,
        pointsize
      );
      line.setFrame(container.frame.w * 0.5, 0.5 * pointsize, 0, margin);
      container.appendChild(point);
      container.update_position = function (world_to_viewport_transform) {
        var P = world_to_viewport_transform.x(this.p);

        this.setFrame(
          P[0] - container.frame.w * 0.5 - 1,
          P[1] - pointsize * 0.5 - 1
        );
      };

      container.p = [ix, iy, iz, 1];
      container.update_position(world_to_viewport_transform);
      root.appendChild(container);
    }

    // Remove on click
    container.click(function () {
      this.remove();
    });

    return container;
  };
})((window.sculpteo = window.sculpteo || {}));
